import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ReportCard } from "@/pages/ReportsPage";

/**
 * Phase 15.6A — Homepage widget showing the latest 3-5 RGM Reports.
 * Drops cleanly into DiscoveryHomePage; hides itself if there are no reports
 * so we don't surface an empty card to anonymous visitors.
 */
const RGMReportsRail = ({ limit = 5 }) => {
  const [reports, setReports] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/reports", { params: { category: "all", limit } });
        setReports(r.data.reports || []);
      } catch { setReports([]); }
      finally { setLoaded(true); }
    })();
  }, [limit]);

  if (!loaded || reports.length === 0) return null;

  return (
    <section className="mb-8" data-testid="home-rgm-reports-rail">
      <div className="flex items-baseline justify-between mb-3">
        <h2 className="text-white text-xl sm:text-2xl font-bold flex items-center gap-2">
          📰 RGM Reports
        </h2>
        <Link to="/reports" className="text-xs text-purple-400 hover:text-purple-300" data-testid="home-rgm-reports-see-all">
          See all →
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {reports.slice(0, 3).map((r) => (
          <ReportCard key={r.report_id} report={r} compact />
        ))}
      </div>
    </section>
  );
};

export default RGMReportsRail;
